import(/* webpackMode: "eager" */ "/app/src/app/(menu)/menu/page.tsx");
